<t4-header> 
</t4-header>
<t4-container title="{{ 'TO.Customers.lblFilter' |translate : 'Filters' }}">
  <mat-checkbox [(ngModel)]="onlyActive" (ngModelChange)="update()">{{ 'TO.Customers.chkOnlyActive' |translate : 'Show only active customers' }}</mat-checkbox>
  @if(Settings.isInAny(['BackOffice']))
  {
  <mat-checkbox [(ngModel)]="showLoadCustomerByNumber" style="margin-right: 16px; margin-left: 16px;">{{ 'TO.Customers.AddMissingCustomerFromAnnata' | translate : 'Add missing customer from Annata' }}</mat-checkbox>
  <ng-container *ngIf="showLoadCustomerByNumber">
    <mat-form-field appearance="outline" style="width:250px; margin-right:8px;">
      <mat-label>{{ 'TO.Customers.CustomerNo' | translate : 'Customer Number' }}</mat-label>
      <input matInput [(ngModel)]="customerNo">
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="GetCustomerFromAnata()" [disabled]="!customerNo?.trim()">
      <mat-icon>person_add</mat-icon>
      <span>{{ 'TO.Customers.GetCustomerFromAnnata' | translate : 'Get Customer' }}</span>
    </button>
  </ng-container>
  }
</t4-container>
<br/>
<t4-container [isLoading]="isLoading">
  <t4-data-table #tblCustomers [rawData]="customersData" matSortActive="DeliveryAddressCustomerName" matSortDirection="asc" headline="{{ 'TO.Customers.Headline' | translate : 'Customers' }}" [cacheTimeInMinutes]="720" [autoGenerateColumns]="false" matSort (itemClicked)="gotoCustomer($event)" [filterFields]="['DeliveryAddressCustomerName', 'DisplayName', 'DeliveryAddress', 'DeliveryCity', 'XalAccountNo', 'CustomerNumber', 'Chain', 'Country', 'TrailerList', 'RentalOrderList', 'SalesRepId','ServicePartner','RepairPartner']">
    <ng-container matColumnDef="Id">
      <mat-header-cell *matHeaderCellDef style="max-width: 75px;"></mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 75px;"><mat-icon style="color: red;" *ngIf="row.IsDeleted">block</mat-icon><mat-icon *ngIf="!row.IsDeleted">business</mat-icon></mat-cell>
    </ng-container>
    <ng-container matColumnDef="XalAccountNo">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 100px;">{{ 'TO.Customers.Table_Customer no' |translate : 'Customer No' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 100px;">{{ row.XalAccountNo }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="DeliveryAddressCustomerName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Customers.Table_Name' |translate : 'Name' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.DeliveryAddressCustomerName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="DisplayName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Customers.Table_DisplayName' |translate : 'Display name' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.DisplayName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="DeliveryAddress">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Customers.Table_Address' |translate : 'Address' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.DeliveryAddress }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="DeliveryCity">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Customers.Table_City' |translate : 'City' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.DeliveryCity }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="ServicePartner">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Customers.Table_ServicePartner' | translate : 'Service partner' }}</mat-header-cell>
      <mat-cell *matCellDef="let row"><t4-order-customer-link [locationId]="row.ServicePartnerId">{{ row.ServicePartner }}</t4-order-customer-link></mat-cell>
    </ng-container>

    <ng-container matColumnDef="RepairPartner">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Customers.Table_RepairPartner' | translate : 'Repair partner' }}</mat-header-cell>
      <mat-cell *matCellDef="let row"><t4-order-customer-link [locationId]="row.RepairPartnerId">{{ row.RepairPartner }}</t4-order-customer-link></mat-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
